import { createOperatorEntityIdGenerator } from "./createOperatorEntityIdGenerator";

/**
 * Returns a new id for an Operator registration, unique among all ids in the page.
 *
 * @param prefix Identifies the kind of control, for example "braze-icon-button"
 * @returns The new id
 */
export const createOperatorEntityId = createOperatorEntityIdGenerator();
